module.exports = __webpack_public_path__ + "static/media/vk.a042cd9b.svg";